module.exports = __webpack_public_path__ + "public/img/1.68c216b5.png";